import { render, staticRenderFns } from "./TSZ_Recordar_Contraseña.vue?vue&type=template&id=92d590a6&scoped=true&"
import script from "./TSZ_Recordar_Contraseña.vue?vue&type=script&lang=js&"
export * from "./TSZ_Recordar_Contraseña.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Recordar_Contraseña.vue?vue&type=style&index=0&id=92d590a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d590a6",
  null
  
)

export default component.exports